import { isEmpty } from 'lodash-es';

export function isObject(maybeObject: unknown) {
  return typeof maybeObject === 'object' && !Array.isArray(maybeObject) && maybeObject !== null;
}

export function isEmptyOrEmptyObject(object: unknown) {
  if (!isObject(object)) {
    return isEmpty(object);
  }

  return Object.keys(object as object).length === 0;
}
